export const rtlLanguages = ['ar', 'he'];
